__turbopack_context__.v({
  "horizontal": "wuR8bq_horizontal",
  "verticalCollapsed": "wuR8bq_verticalCollapsed",
  "verticalExpanded": "wuR8bq_verticalExpanded",
});
